import { ComponentProps } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import { cn } from "../../lib/utils";

export function AccordionHeader({ className, ...props }: ComponentProps<typeof AccordionPrimitive.Header>) {
  return <AccordionPrimitive.Header data-slot="accordion-header" className={cn("flex", className)} {...props} />;
}
